<script lang="ts" setup>
  import { ExternalRoute } from "@/constants/externalRoute"
  import { MyAccountRoute } from "@/constants/routes/myAccount"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>We're sorry you've not been happy with our service.</h4>
  <p>
    When signing up to So Energy, we will only send you essential emails about
    your switch and activating your account. After this you shouldn't get many
    emails from us.
  </p>
  <p>
    If you signed up to receive marketing communications you may have received
    extra emails but it's easy to opt out of receiving more by
    <Link
      class="link text-primary-600"
      :to="MyAccountRoute.marketingContactPreferences"
    >
      changing your preferences in your account
    </Link>
    .
  </p>
  <p>
    We'd hate this to be the reason you cancelled your switch as we pride
    ourselves in our customer service. If you're unable to change your account
    preferences yourself, you can always
    <Link class="link text-primary-600" :to="ExternalRoute.contactUs">
      get in touch
    </Link>
    with our friendly team.
  </p>
</template>
